// extracted by mini-css-extract-plugin
module.exports = {"root":"BannerCarousel_root__aD5KD","slide":"BannerCarousel_slide__2q3vl","bannerImg":"BannerCarousel_bannerImg__3a2KO","dotList":"BannerCarousel_dotList__1gPn8"};